import { createStore } from 'vuex';
import { useRoute } from 'vue-router';

const store = {
  state() {
    const memberCode = '';
    const projectCode = '';
    const apiToken = '';
    const mapList = [];

    return {
      memberCode,
      projectCode,
      apiToken,
      mapList,
    };
  },
  mutations: {
    setToken: (state, newToken) => {
      state.apiToken = newToken;
    },
    setMemberCode: (state, newMemberCode) => {
      state.memberCode = newMemberCode;
    },
    setProjectCode: (state, newProjectCode) => {
      state.projectCode = newProjectCode;
    },
    setMapList: (state, newMapList) => {
      state.mapList = newMapList;
    },
  },
  getters: {
    getToken: (state) => () => state.apiToken,
    getMemberCode: (state) => () => state.memberCode,
    getProjectCode: (state) => () => state.projectCode,
    getMapList: (state) => () => state.mapList,
    getMapName: (state) => () => {
      let name = '';
      state.mapList.forEach((item) => {
        if (item.projectCode === state.projectCode) {
          name = item.name;
        }
      });
      return name;
    },
    getColor: (state) => (colorIndex) => {
      const route = useRoute();
      const defaultColor = route.query.tc ? `#${route.query.tc}` : '';
      let color = '';
      state.mapList.forEach((item) => {
        if (item.projectCode === state.projectCode) {
          color = item.hexList[0][`hex${colorIndex - 1}`];
        }
      });
      return color || defaultColor;
    },
    getShareMessage: (state) => () => {
      let message = '';
      state.mapList.forEach((item) => {
        if (item.projectCode === state.projectCode) {
          message = item.copyWrite;
        }
      });
      return message;
    },
  },
};

export default createStore(store);
